import { io } from 'socket.io-client';

let socket = null;
let currentBaseUrl = null;

const createSocket = ( baseUrl ) => {
  const s = io( baseUrl, {
    path: '/v1/client/utility/service/socket.io'
  } );

  s.on( 'connect', () => {
    // eslint-disable-next-line no-console
    console.log( 'Shared Socket connected', s.id );
  } );

  s.on( 'connect_error', ( err ) => {
    // eslint-disable-next-line no-console
    console.error( 'Shared Socket connect error:', err );
  } );

  s.on( 'disconnect', ( reason ) => {
    // eslint-disable-next-line no-console
    console.log( 'Shared Socket disconnected:', reason );
  } );

  return s;
};

export const getSocket = ( baseUrl ) => {
  if( !socket ){
    currentBaseUrl = baseUrl;
    socket = createSocket( baseUrl );
    return socket;
  }

  if( currentBaseUrl === baseUrl ){
    return socket;
  }

  socket.removeAllListeners();
  socket.disconnect();

  currentBaseUrl = baseUrl;
  socket = createSocket( baseUrl );

  return socket;
};